import {AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {language} from '../../../../language/vn';
import { ToastrService } from 'ngx-toastr';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {Subject} from 'rxjs';
import {DatePipe} from '@angular/common';
import {CommandUtil} from '../../../../global/commandutil';
import {environment} from '../../../../../environments/environment';
import {Sessioncommand} from '../../../../global/sessioncommand';
import {RolePermissionService} from '../../../../service/security/service-rolepermission';


@Component({
  templateUrl: './insocv.component.html'

})
export class InSoCongVanDenComponent implements OnInit, AfterViewInit {
  public language = language;
  public fromDate: Date;
  public toDate: Date= new Date();
  public  onClose: Subject<boolean>;
  public urlInSoCongVan: string = environment.printVBDSoCongVan;
  private moduleName:  string = 'egov.info.vanbanden.insocv';
  private permissionPrintCV: boolean = false;
  constructor(  public toastr: ToastrService,
                public bsModalService: BsModalService,
                public datepipe: DatePipe,
                public _bsModalRef: BsModalRef,
                public commandUtils: CommandUtil,
                public rolePermissionService: RolePermissionService
  ) {
  }
  ngAfterViewInit() {
  }

  public edit() {
  }

  ngOnInit(): void {
    this.rolePermissionService.checkPermissionByCode(Sessioncommand.staffId, this.moduleName, environment.insocongvan
    ).subscribe( x => this.permissionPrintCV = x);
    this.onClose = new Subject();
  }

  public onSave(): void {
    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public onCancel(): void {
    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public hideConfirmationModal(): void {
    this.onClose.next(null);
    this._bsModalRef.hide();
  }

}

